/* eslint-disable */
import React, { useState } from 'react';
import {
  TableRow,
  TableCell,
  Chip,
  Typography,
  Link,
  IconButton,
  Collapse,
  Box,
} from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import type { ProductTimelineItem } from '../../types/productDashboard';
import { DeliveryStatusBadge } from './DeliveryStatusBadge';
import { ProgressIndicator } from './ProgressIndicator';
import { DeliveryTicketList } from './DeliveryTicketList';

interface SRTableRowProps {
  item: ProductTimelineItem;
}

export const SRTableRow: React.FC<SRTableRowProps> = ({ item }) => {
  const jiraBaseUrl = 'https://outsight.atlassian.net/browse';
  const [expanded, setExpanded] = useState(false);

  const handleToggleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <>
      <TableRow
        hover
        sx={{
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}
      >
        {/* Expand/Collapse toggle */}
        <TableCell>
          <IconButton
            size="small"
            onClick={handleToggleExpand}
            aria-label={expanded ? 'Collapse delivery details' : 'Expand delivery details'}
            sx={{
              transition: 'transform 0.2s',
              transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          >
            {expanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </TableCell>

      {/* SR Key as Chip linking to Jira */}
      <TableCell>
        <Link
          href={`${jiraBaseUrl}/${item.sr_key}`}
          target="_blank"
          rel="noopener noreferrer"
          underline="none"
        >
          <Chip
            label={item.sr_key}
            size="small"
            color="primary"
            variant="outlined"
            clickable
            sx={{
              fontWeight: 'bold',
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: 'primary.light',
                color: 'primary.contrastText',
              },
            }}
          />
        </Link>
      </TableCell>

      {/* SR Title */}
      <TableCell>
        <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
          {item.sr_title}
        </Typography>
      </TableCell>

      {/* SR Status */}
      <TableCell>
        <Chip
          label={item.sr_status}
          size="small"
          color={
            item.sr_status === 'Done'
              ? 'success'
              : item.sr_status === 'In Progress'
              ? 'primary'
              : 'default'
          }
          variant="filled"
        />
      </TableCell>

      {/* Expected Version */}
      <TableCell>
        <Typography variant="body2" color="text.secondary">
          {item.expected_version || '—'}
        </Typography>
      </TableCell>

      {/* Delivery Status */}
      <TableCell>
        <DeliveryStatusBadge status={item.delivery_status as any} />
      </TableCell>

      {/* Progress */}
      <TableCell>
        {item.delivery_summary ? (
          <ProgressIndicator deliverySummary={item.delivery_summary} size="small" />
        ) : (
          <Typography variant="caption" color="text.secondary">
            No delivery data
          </Typography>
        )}
      </TableCell>
    </TableRow>

    {/* Expanded row with delivery details */}
    <TableRow>
      <TableCell colSpan={7} sx={{ p: 0, border: 0 }}>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Box
            sx={{
              backgroundColor: 'grey.100',
              borderTop: '1px solid',
              borderColor: 'divider',
              p: 2,
            }}
          >
            <DeliveryTicketList epics={item.epics} />
          </Box>
        </Collapse>
      </TableCell>
    </TableRow>
    </>
  );
};
